import { ParticipantCard } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/Participants/components/ParticipantCard';
import { useParticipants } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/Participants/hooks/useParticipants';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { Participant } from '@/config/types';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';

interface AdminAgentCardProps {
  merchantStructure: MerchantStructureEntity;
}

export const AdminAgentCard = ({ merchantStructure }: AdminAgentCardProps) => {
  const agent = merchantStructure.getAgentOrFirstAgent();

  const participants: { agent?: Participant; channel?: Participant; merchant?: Participant } = useParticipants({
    agentId: agent.id,
    merchantId: merchantStructure.getMerchant().id,
  });

  return (
    <CustomPaper fill="paper">
      <Font variant="h5" color="title">
        <Text strong tId={'SALES_CHANNEL'} />
      </Font>
      <FlexColumn gridGap={0} pt={2}>
        {Object.values(participants)
          .filter((participant) => !!participant)
          .map((participant, key) => (
            <ParticipantCard
              key={key}
              hideIcon
              forceSingleLine
              participant={participant}
              padding="8px 16px !important"
            />
          ))}
      </FlexColumn>
    </CustomPaper>
  );
};
